import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageMurcia = props => {
  return <CityLandingPage cityKey="Murcia" cityConfig={cityContent.murcia} {...props} />;
};

export default LandingPageMurcia;
